/**
 * Build owner prioritised keys. For example:
 *
 * root: 'x'
 * isBusiness: false
 * key: 'y'
 *
 * returns `x.y`
 *
 * root: 'x'
 * isBusiness: true
 * key: 'y'
 *
 * returns `x.business.y`, `x.y`
 *
 * @param {String} root
 * @param {Boolean} isBusiness
 * @param {String} keySuffix
 * @return {String} translation key
 */
export const buildBusinessPrioritisedKey = (root, isBusiness, keySuffix) => {
    let key = `${root}.${keySuffix}`;

    if (isBusiness) {
        key = `${root}.business.${keySuffix}`;
    }

    return key;
};
